
import React from 'react';
import SEO from '@/components/SEO';
import { Separator } from '@/components/ui/separator';

const Papers = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <SEO
        title="Research & Papers | Stratodata"
        description="Deep-dive research and whitepapers on retail data strategy, ecommerce analytics, and data maturity from the Stratodata team."
        canonical="/papers"
      />
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mt-8 mb-4">Papers</h1>
          <p className="text-lg text-muted-foreground mb-8">
            In-depth research and technical papers on advanced data science topics.
          </p>
          
          <Separator className="my-8" />
          
          <div className="py-12 text-center">
            <p className="text-xl text-muted-foreground">
              Research papers coming soon.
            </p>
            <p className="mt-4 text-muted-foreground">
              Check back later for our published papers and research findings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Papers;
